
import { makeStyles } from 'tss-react/mui';

export const useDefaultStackStyles = makeStyles()(({ spacing }) => ({
  container: {
    display: 'flex',
    flexDirection: 'column',
  },
  containerFlexItem: {
    flex: 1,
  },
}));
